<template>
    <div class="reports_box" v-infinite-scroll="loadMore" infinite-scroll-disabled="pullUpLoading" infinite-scroll-distance="10">
        <div class="nav flex_box bg_fff">
            <section :id='index' v-for="(item,index) in reportsNavList" :key='index'
                     :class="{ active: selected === index }" @click="selected = index">
                <p>{{ item }}</p>
                <p class="subLine"></p>
            </section>
        </div>
        <div class="list" v-if="selected === 0">
            <div v-for="(list, date) in reports" :key="date">
                <p class="date_str fs12 font_n">{{ date }}</p>
                <section class="bg_fff flex_box justify-content_flex-justify" v-for="(v, k) in list" :key="k" @click="gotoReport(v)">
                    <div class="left line-clamp_2">
                        <p class="title fs16 font_n line-clamp_1">
                            <span v-if="!v.read" class="redPoint bg_red"></span>
                            {{ v.title }}</p>
                        <p class="time fs12 font_n">{{ (v.updatedDate)| formatDate("YYYY-MM-DD HH:mm") }}</p>
                    </div>
                    <div class="right">
                        <img v-if="v.status === 'finished'" src="../assets/img/report/forwardBtn.png" alt="导出">
                        <p v-else class="fs12 co_9EA font_b desc">生成中..</p>
                    </div>
                </section>
            </div>
        </div>
        <div v-if="selected === 1">

        </div>
        <!-- loading box -->
        <section class="loadingBg" v-if="loading">
            <mt-spinner type="double-bounce" color="#26a2ff"></mt-spinner>
        </section>
        <div class="report_btn">
            <a class=" fs18 font_b co_fff" @click="toCreate">创建报告</a>
        </div>

    </div>
</template>

<script>


import req from "@/util/request";
import _co from "@/util/const";
import moment from "moment";
import _ from "loadsh";
import common from "@/util/common";

export default {
    name: 'Reports',
    components: {},
    props: {},
    data() {
        return {
            loading: false,
            pullUpLoading: false,
            currentPage: 0,
            reportsNavList: _co.reportsNavList,
            selected: 0,
            reports: {},
            query: {
                limit: 10,
                skip: 0
            },
            renderList: []
        }
    },
    filters: {},
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            this.pullUpLoading = true;
            this.loading = true;
            this.query.skip = this.currentPage *  this.query.limit;
            let res = await req.getReports(this.query);
            this.renderList = this.renderList.concat(res.list);
            this.pullUpLoading = this.renderList.length === res.count;
            this.reports = this.formatReportData(this.renderList);
            this.loading = false;
        },
        async init() {
            this.currentPage = 0;
            this.selected = 0;
            this.reportsNavList = _co.reportsNavList;
            this.reports = {};
            this.query = {
                limit: 10,
                skip: 0,
            }
            this.renderList = [];
            this.getData();
        },
        async gotoReport(item) {
            if (item.version < 2) {
                try {
                    let resp = await this.$messagebox.confirm('', {
                        title: '提示',
                        message: '报告已过期，是否重新生成？',
                        confirmButtonText: '重新生成'
                    })
                    if (resp === 'confirm') {
                        await this.baseApi.updateReport(item._id);
                        this.init();
                    }
                    return;
                } catch {
                    return;
                } 
            }
            if (item.status !== 'finished')
                return;
            this.$router.push(`/reports/${item._id}?title=${item.title}`);
        },
        formatReportData(list) {
            let obj = _.chain(list)
                .each(function (item) {
                    item.dateStr = moment(item.updatedDate).format("YYYY-MM-DD");
                    item.title = `${moment(item.endTime).format(`${item.period == "day" ? "YYYY年MM月DD日" :"YYYY年MM月"}`)} ${item.entityType === 'industry' ? common.convertEntityName(item.entityId) : item.entityId}${_co.reportPeriodMap[item.period]}报`

                })
                .groupBy("dateStr")
                .mapKeys(function (v, k) {
                    let diff = moment().diff(k, "days");
                    if (diff > 0 && diff <= 7) {
                        k = `${diff}天前`;
                    } else if (diff == 0) {
                        k = '';
                    }
                    return k
                })
                .value()

            return obj
        },
        async loadMore() {
            this.currentPage++;
            await this.getData();
        },
        toCreate() {
            sessionStorage.clear();
            this.$router.push('/createReport');
        }
    }
}
</script>

<style lang="scss" scoped>
.reports_box {
    .nav {
        font-size: 16px;
        height: 52px;
        line-height: 52px;
        margin-bottom: 8px;

        section {
            width: 100%;
            text-align: center;
            position: relative;

            .subLine {
                width: 48px;
                height: 3px;
                background-color: rgba(3, 57, 159, 1);
                border-radius: 10px;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                display: none;
            }
        }

        .active {
            color: rgba(51, 51, 51, 1);
            font-weight: bold;

            .subLine {
                display: inline-block
            }
        }

    }

    .list {
        .date_str {
            font-family: PingFangSC-Regular;
            color: #B0B0B0;
            letter-spacing: 0;
            line-height: 16px;
            padding: 16px 16px 10px 16px;
        }

        section {
            height: auto;
            padding: 16px;
            border-bottom: 1px solid #f5f6f8;
        }

        .left {
            width: 276px;

            .title {
                font-family: PingFangSC-Regular;
                color: #333333;
                letter-spacing: 0;
                line-height: 20px;
                margin-bottom: 8px;
            }

            .time {
                color: #666666;
                letter-spacing: 0;
                line-height: 16px;
            }
        }

        .right {
            width: 67px;
            align-self: center;

            img {
                width: 24px;
                height: 24px;
                float: right;
            }

            .desc {
                float: right;
            }
        }
    }

    .report_btn {
        height: 48px;
        margin-top: 48px;
        a{
            width: 100%;
            height: 48px;
            line-height: 48px;
            font-family: PingFangSC-Medium;
            background-color: #538DFF;
            letter-spacing: 0;
            text-align: center;
            position: fixed;
            bottom: 0;
            left: 0;
        }
    }

}
</style>
